import { EntityState } from '@ngrx/entity';
import { createReducer, on } from "@ngrx/store";
import * as fromActions from '../actions';
import { Filter, FilterIdExtractor } from "../models";
import { filterAdapter } from '../state';

const initState: EntityState<Filter> = filterAdapter.getInitialState();

export const selectedFilterReducer = createReducer(
  initState,
  on(fromActions.addSelectedFilter, (state, { filter }) => filterAdapter.addOne(filter, state)),
  on(fromActions.removeSelectedFilter, (state, { filter }) => filterAdapter.removeOne(FilterIdExtractor(filter), state)),
  on(fromActions.setSelectedFilters, (state, { filters }) => filterAdapter.setAll(filters, state)),
  on(fromActions.removeAllFilters, state => filterAdapter.removeAll(state))
)

export const filtersReducer = createReducer(
  initState,
  on(fromActions.addFilters, (state, { filters }) => filterAdapter.addMany(filters, state))
)
